import React from 'react';

import { MarketingFAQ } from 'client/components/MarketingPagesShared/MarketingFAQ';
import { useT } from 'client/i18n/hooks/useT';
import { TextLink } from '@spotify-internal/encore-web';

const riversideUrlWithoutUserParams =
  'https://riverside.fm/anchor?utm_source=anchor&utm_medium=dashboard_banner&utm_campaign=integration';

export function FAQ() {
  const t = useT();

  const FAQList = [
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.SwitchPodcastQuestion',
        'How do I switch an existing podcast to Anchor?',
        'Integration Connection Screen, FAQ section how to switch question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.SwitchPodcastAnswer',
        'If you want to {switchLink}, just provide the RSS feed of your podcast and create an Anchor account. We’ll do the rest.',
        'Integration Connection Screen, FAQ section how to switch answer',
        {
          switchLink: (
            <TextLink href="/switch">
              {t(
                'IntegrationConnectionScreen.FAQ.SwitchLink',
                'Switch to Anchor',
                'The link to take users to the Switch to anchor marketing page'
              )}
            </TextLink>
          ),
        }
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.ImportVideoQuestion',
        'Can I import videos from other programs?',
        'Integration Connection Screen, FAQ section import programs question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.ImportVideoAnswer',
        'Yes. We currently allow videos to be imported from {riversideLink}. Video files can also be uploaded directly from your computer.',
        'Integration Connection Screen, FAQ section import programs answer',
        {
          riversideLink: (
            <TextLink href={riversideUrlWithoutUserParams}>
              {t(
                'IntegrationConnectionScreen.FAQ.RiversideLink',
                'Riverside.fm',
                'The link to take users to riverside'
              )}
            </TextLink>
          ),
        }
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.SharingQuestion',
        'Can I share the same content I share on other platforms?',
        'Integration Connection Screen, FAQ section sharing question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.SharingAnswer',
        'Yes! Upload your files to Anchor and unlock new audiences on Spotify in just a few clicks.',
        'Integration Connection Screen, FAQ section sharing answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.VideoFormatsQuestion',
        'What video formats are accepted?',
        'Integration Connection Screen, FAQ section video format question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.VideoFormatsAnswer',
        'We currently accept mp4 and mov files and recommend a 16x9 aspect ratio.',
        'Integration Connection Screen, FAQ section video format answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.AvailabilityQuestion',
        'Where will my videos be available?',
        'Integration Connection Screen, FAQ section video availability question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.AvailabilityAnswer',
        'They’ll be on Spotify in every country and region where videos are available. The audio version of your episode will be available everywhere you distribute your podcast.',
        'Integration Connection Screen, FAQ section video availability answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.EligibilityQuestion',
        'Who can create video podcasts?',
        'Integration Connection Screen, FAQ section eligibility question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.EligibilityAnswer',
        'Video podcasts are currently available in the United States, United Kingdom, Australia, Canada, and New Zealand.',
        'Integration Connection Screen, FAQ section eligibility answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.LiveStreamQuestion',
        'Can I stream live?',
        'Integration Connection Screen, FAQ section stream live question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.LiveStreamAnswer',
        'No, but you can check out Spotify Live for live audio streaming options.',
        'Integration Connection Screen, FAQ section stream live answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.WhyVideoQuestion',
        'Why is Spotify adding video?',
        'Integration Connection Screen, FAQ section why video question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.WhyVideoAnswer',
        'Spotify has always been a premier destination for content. Whether listening to a newly released album or finding a new podcast, the world comes to Spotify to discover. By adding video, we are ensuring that regardless of what someone is looking for, they can find it on Spotify.',
        'Integration Connection Screen, FAQ section why video answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.ExistingAudioEpisodesQuestion',
        'Can I add video to my existing audio episodes in Anchor?',
        'Integration Connection Screen, FAQ section add video to existing audio question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.ExistingAudioEpisodesAnswer',
        'Yes you can! Simply replace the existing audio file with a video file and it’ll be automatically updated. You can have both audio and video episodes in the same podcast.',
        'Integration Connection Screen, FAQ section add video to existing audio answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.MonetizeVideosQuestion',
        'Can I monetize my videos?',
        'Integration Connection Screen, FAQ section monetize question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.MonetizeVideosAnswer',
        'Yes — in addition to your own advertising partnerships, several monetization options including Paid Podcast Subscriptions and Ads by Anchor will be available for video podcasts soon. We are constantly adding new monetization opportunities for Anchor creators.',
        'Integration Connection Screen, FAQ section monetize answer'
      ),
    },
  ];

  return <MarketingFAQ FAQList={FAQList} />;
}
